import { render } from "./VatView.vue?vue&type=template&id=5c0fdc18"
import script from "./VatView.vue?vue&type=script&lang=js"
export * from "./VatView.vue?vue&type=script&lang=js"

import "./VatView.vue?vue&type=style&index=0&id=5c0fdc18&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/VatView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c0fdc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c0fdc18', __exports__)) {
    api.reload('5c0fdc18', __exports__)
  }
  
  module.hot.accept("./VatView.vue?vue&type=template&id=5c0fdc18", () => {
    api.rerender('5c0fdc18', render)
  })

}


export default __exports__